/*
 *  SeekBar.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import styled from "styled-components";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const SeekBar = styled.input.attrs({ type: "range" })`
  &&& {
    -webkit-appearance: none;
    margin: 10px 0 5px;
    width: 100%;
    &:focus {
      outline: none;
    }
    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
      background: #3071a9;
      border-radius: 3px;
      border: 0.2px solid #010101;
    }
    &::-webkit-slider-thumb {
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
      border: 1px solid #000000;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background: #ffffff;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -7px;
    }
    &:focus&::-webkit-slider-runnable-track {
      background: #367ebd;
    }
    &::-moz-range-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
      background: #3071a9;
      border-radius: 3px;
      border: 0.2px solid #010101;
    }
    &::-moz-range-thumb {
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
      border: 1px solid #000000;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background: #ffffff;
      cursor: pointer;
    }
    &::-ms-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      border-width: 16px 0;
      color: transparent;
    }
    &::-ms-fill-lower {
      background: #2a6495;
      border: 0.2px solid #010101;
      border-radius: 4px;
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }
    &::-ms-fill-upper {
      background: #3071a9;
      border: 0.2px solid #010101;
      border-radius: 4px;
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }
    &::-ms-thumb {
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
      border: 1px solid #000000;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background: #ffffff;
      cursor: pointer;
    }
    &:focus&::-ms-fill-lower {
      background: #3071a9;
    }
    &:focus&::-ms-fill-upper {
      background: #367ebd;
    }
  }
`;
export default SeekBar;
